/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Skip_RestInputs */

const en_us2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip rest`)
};

const pt_br2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pular descanso`)
};

const es_419_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar descanso`)
};

const pt_pt2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar descanso`)
};

const fr_fr2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer le repos`)
};

const de_de2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause überspringen`)
};

const it_it2_workout_skip_rest = /** @type {(inputs: Workout_Skip_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta recupero`)
};

/**
* | output |
* | --- |
* | "Skip rest" |
*
* @param {Workout_Skip_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_skip_rest = /** @type {((inputs?: Workout_Skip_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Skip_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_skip_rest(inputs)
	if (locale === "es-419") return es_419_workout_skip_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_skip_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_skip_rest(inputs)
	if (locale === "de-DE") return de_de2_workout_skip_rest(inputs)
	if (locale === "it-IT") return it_it2_workout_skip_rest(inputs)
	return en_us2_workout_skip_rest(inputs)
});
export { workout_skip_rest as "workout.skip_rest" }